import React, { Fragment, useMemo, useState } from 'react'

import {
  Avatar,
  Icon,
  DeleteFilled,
  Edit,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOfType, object, string, number, oneOf } from 'prop-types'

import { timeAgo } from 'Utils/FormatDate'

import CommentsForm from './CommentsForm'
import { useComments } from '../Hooks/useComments'
import { useCommentsContext } from '../Hooks/useCommentsContext'

function SimpleComment({ id, content, author, createdAt }) {
  const { username, avatarUrl } = author || {}
  const { isRequesting, removeComment } = useComments()
  const { userData } = useCommentsContext()
  const timeFrom = useMemo(() => timeAgo(createdAt), [])
  const [isFormVisible, toggleForm] = useState(false)
  const canEdit = username === userData?.currentUserUsername
  const canDelete = canEdit || userData?.currentUserIsAdmin

  return (
    <article className="comment comment--depth-0">
      <header className="comment__info">
        <strong>
          {username}
        </strong>{' '}
        {createdAt && (
          <Fragment>
            wrote
            <span content={createdAt} itemProp="datePublished">
              {' '}
              {timeFrom}
            </span>
          </Fragment>
        )}
        {id && createdAt && (
          <div className="comment__actions">
            <ul>
              {canEdit && (
                <li
                  onClick={() => {
                    toggleForm((currentIsFormVisible) => !currentIsFormVisible)
                  }}
                >
                  <span className="comment__action">
                    <div className="cgt-tooltip-container">
                      <Icon
                        svgComponent={Edit}
                        color="primary"
                        size="small"
                        withHover
                        disabled={isRequesting}
                      />
                      <div className="cgt-tooltip cgt-tooltip--top">
                        <p className="cgt-tooltip__text">Edit</p>
                      </div>
                    </div>
                  </span>
                </li>
              )}
              {canDelete && (
                <li
                  onClick={() => {
                    const authenticityToken = window.getToken()

                    if (authenticityToken) {
                      removeComment({ id, token: authenticityToken })
                    }
                  }}
                >
                  <span className="comment__action">
                    <div className="cgt-tooltip-container">
                      <Icon
                        svgComponent={DeleteFilled}
                        color="primary"
                        size="small"
                        withHover
                        disabled={isRequesting}
                      />
                      <div className="cgt-tooltip cgt-tooltip--top">
                        <p className="cgt-tooltip__text">Remove</p>
                      </div>
                    </div>
                  </span>
                </li>
              )}
            </ul>
          </div>
        )}
      </header>
      <div className="comment__author">
        <Avatar img={avatarUrl} username={username} size="48" />
      </div>

      <div className="comment__body">
        {isFormVisible ? (
          <CommentsForm
            isEditMode
            defaultContent={content}
            commentId={id}
            submitCallback={() => {
              toggleForm(false)
            }}
          />
        ) : (
          content
        )}
      </div>
    </article>
  )
}

SimpleComment.propTypes = {
  id: oneOfType([string, number, oneOf([null])]).isRequired,
  content: string.isRequired,
  author: object.isRequired,
  createdAt: string.isRequired,
}

export default SimpleComment
